"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UCAT_THEME_ANALYTICS = exports.UCAT_ANALYTICS = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
exports.UCAT_ANALYTICS = (0, client_1.gql) `
  query UcatAnalytics($updatedAt: Date, $entitlementId: Int) {
    restricted {
      ucatAnalytics(updatedAt: $updatedAt, entitlementId: $entitlementId) {
        id
        name
        timeTaken
        avgTimeTaken
        total
        completed
        score
        avgScore
        stats {
          id
          name
          timeTaken
          avgTimeTaken
          total
          completed
          score
          avgScore
        }
      }
    }
  }
`;
exports.UCAT_THEME_ANALYTICS = (0, client_1.gql) `
  ${fragments_1.QUESTION_CATEGORY_FIELDS}
  query UcatThemeAnalytics(
    $entitlementId: Int
    $themeId: Int
    $updatedAt: Int
  ) {
    restricted {
      ucatThemeAnalytics(
        entitlementId: $entitlementId
        themeId: $themeId
        updatedAt: $updatedAt
      ) {
        attempted
        correct
        incorrect
        marks {
          questionId
          updatedAt
          marksheet {
            id
            isTestMarksheet
          }
          question {
            id
            typeId
            ...QuestionCategoryFields
          }
        }
        stats {
          attempted
          avgScore
          correct
          date
          incorrect
          score
        }
        total
        userId
      }
    }
  }
`;
